module.exports = __webpack_public_path__ + "img/case-logo-32.85645e61.png";